// extracted by mini-css-extract-plugin
export default {"title":"OZ8BQhpC","text":"SRKepsjB"};